import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

import ct1_1min from '../assets/img/create-tracks/coke/ct1_1min-min.jpg'
import ct1_2min from '../assets/img/create-tracks/coke/ct1_2min-min.jpg'
import ct1_3min from '../assets/img/create-tracks/coke/ct1_3min-min.jpg'
import ct1_4min from '../assets/img/create-tracks/coke/ct1_4min-min.jpg'
import ct1_5min from '../assets/img/create-tracks/coke/ct1_5min-min.jpg'
import ct1_6min from '../assets/img/create-tracks/coke/ct1_6min-min.jpg'


const T3_1 = (props) => {
  const arrImgmin = [ ct1_1min, ct1_2min, ct1_3min, ct1_4min, ct1_5min, ct1_6min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + '/assets/ct1_1.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct1_2.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct1_3.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct1_4.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct1_5.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/ct1_6.jpg'}
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/create-tracks' >
      <ScrollToTopOnMount />
      <Trans i18nKey='T3_1'>
        <p>
          Кокедама (з японської «куля з моху») - це різновид фітодизайну. Цей модний напрям декорування приміщення рослинами прийшов до нас з Японії.
        </p>
        <p>
          Секрет розташування кокемади дуже простий: рослина може бути розставлена в інтер’єрі або підвішена в повітрі.
        </p>
        <p>
          Кокедама у Вашому інтер’єрі – це: <br/>
          - новий модний тренд у фітодизайні; <br/>
          - рослини в повітрі; <br/>
          - вражені та захоплені гості і клієнти; <br/>
          - екологічно чистий мікроклімат у приміщенні.
        </p>
        <p className="prise">
          Вартість створення кокедами починається від 250 грн і залежить від виду рослини, розміру та способу кріплення.
        </p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(T3_1)


// WEBPACK FOOTER //
// ./src/page/T3_1.jsx